
import React from 'react';
import TotalListPrice from 'bom/components/TotalListPrice';
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Paper } from '@mui/material';
import { calculatePrices } from 'bom/bomHelpers';

type Props = {
  data: bomPartsList,
};

export default class CombinedProjectsTable extends React.Component<Props> {
  tableRows() {
    const { data } = this.props;
    return data.map((part, index) => (
        <TableRow key={part.number || index}>
          <TableCell>{part.number}</TableCell>
          <TableCell className={part.category}>{part.type}</TableCell>
          <TableCell>{part.description}</TableCell>
          <TableCell>{part.quantity}</TableCell>
          <TableCell>{part.price}</TableCell>
          <TableCell>{(part.price * part.quantity).toFixed(2)}</TableCell>
        </TableRow>
      ));
  }

  totalListPrice() {
    const { accessoriesPrice, baseSystemPrice } = calculatePrices(this.props.data);
    return (
      <TableRow key="total_row" className="part-row" sx={{ borderTop: '2px solid #e0e0e0' }}>
        <TableCell colSpan={6} sx={{ padding: '16px' }}>
          <TotalListPrice totalPrice={Number((accessoriesPrice + baseSystemPrice).toFixed(2))} />
        </TableCell>
    </TableRow>
    );
  }

  render() {
    
    return (
      <TableContainer component={Paper}>
        <Table className="combined-projects-table">
          <TableHead>
            <TableRow>
              <TableCell>PART NUMBER</TableCell>
              <TableCell>PART TYPE</TableCell>
              <TableCell>DESCRIPTION</TableCell>
              <TableCell>QUANTITY</TableCell>
              <TableCell>UNIT PRICE (USD)</TableCell>
              <TableCell>TOTAL LIST PRICE (USD)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.tableRows().concat(this.totalListPrice())}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}
